<template>
    <div>
        <b-nav-item-dropdown
            :text="defaultText"
            class="justify-content-end"
            toggle-class="pl-1"
            right
        >
          <template #button-content>
            <slot>
              <client-logo v-if="currentClient" />
            </slot>
          </template>

            <b-dropdown-item v-for="client in clients"
                             :key="client.clientId"
                             @click="changeClient(client)">
                {{ client.client }}
            </b-dropdown-item>
        </b-nav-item-dropdown>
        <riskhub-vue-element-loading :active="loading" :is-full-screen="true" />
    </div>
</template>

<script>
import Client from "@/services/Client/Client";
import User from "@/services/User/User";
import ErrorMixin from "@/components/Notifications/ErrorMixin";
import { mapActions, mapGetters } from 'vuex';
import ClientLogo from '@/components/Logo/ClientLogo.vue';

export default {
  name: 'Change-client',
  components: { ClientLogo },
  mixins: [ErrorMixin],
  props: {
    defaultText: {
      type: String,
      default: 'Change Client',
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapGetters({ clients: 'clients', currentClient: 'userClient'}),
  },
  methods: {
    ...mapActions(['setPropertyTenure', 'resetTags']),
    async changeClient({ clientId }) {
      // Change client ID of user
      this.loading = true;
      try {
        await User.changeClient(clientId);

        await this.resetTags();
        this.setPropertyTenure(null);

        this.$emit('change');
      } catch (e) {
        this.showErrorMessage(e);
        this.loading = false;
      }
    },
  },
};
</script>
